/**
 * "X seconds/minutes/hours ago" formatting for the Recently Sold feed (and
 * anywhere else a chain timestamp needs to read like AtomicHub's relative
 * times instead of a raw date). Falls back to an absolute date once
 * something is old enough that "47 days ago" stops being useful.
 */
export function formatRelativeTime(msEpoch: number): string {
  const diffMs = Date.now() - msEpoch;
  if (!Number.isFinite(diffMs) || diffMs < 0) return "just now";

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds} second${seconds === 1 ? "" : "s"} ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;

  return new Date(msEpoch).toLocaleDateString();
}
